/* 🤖 this file was generated by svg-to-ts */
export const siriusCreditCardDuotone: {
  name: 'credit_card_duotone';
  data: string;
} = {
  name: 'credit_card_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M21.75 9v9a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V9h19.5Z" fill="currentColor"/><path d="M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5ZM21 6v2.25H3V6h18Zm0 12H3V9.75h18V18Zm-1.5-2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 0 1 .75.75Zm-6 0a.75.75 0 0 1-.75.75h-1.5a.75.75 0 1 1 0-1.5h1.5a.75.75 0 0 1 .75.75Z" fill="currentColor"/></svg>`
};
